var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height"},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-autocomplete',{attrs:{"label":"Test custom filters","items":_vm.states,"filter":_vm.activeFilter,"filled":"","rounded":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }